<div class="bn-semaphore-tooltip"
     tooltipClass="bn-semaphore-tooltip__tooltip"
     placement="right"
     [ngbTooltip]="text">
  <div [ngClass]="type"
       class="bn-semaphore-tooltip__icon"></div>
</div>
